import { capabilities_request } from './util'; 

class Capabilities {
    
    constructor(capabilities) {
        this.capabilities = capabilities;
    }
    
    getVersion() {
        return this.capabilities.version;
    }
    
    getLayer() {
        return this.capabilities.Capability.Layer;
    }
    
    getInfoFormats() {
        const { Capability } = this.capabilities;
        const { Request } = Capability || {};
        const { GetFeatureInfo } = Request || {};
        
        if( GetFeatureInfo ) {
            return GetFeatureInfo.Format;
        } else {
            return null;
        }
    }    
}

const wms = async (url) => {
    const WMSCapabilities = await import(/* webpackChunkName: "wms_capabilities" */ 'ol/format/WMSCapabilities').then(module => module.default);
    
    const response = await capabilities_request(url, "WMS", "1.3.0", WMSCapabilities);       
    console.log(response);
    
    const { Capability } = response || {};
    if( Capability && Capability.Layer ) {
        return new Capabilities(response);
    }
}

export {
	wms
}